import { render, staticRenderFns } from "./HitPhoneWidget.vue?vue&type=template&id=40b13f88&scoped=true&"
import script from "./HitPhoneWidget.vue?vue&type=script&lang=js&"
export * from "./HitPhoneWidget.vue?vue&type=script&lang=js&"
import style0 from "./HitPhoneWidget.vue?vue&type=style&index=0&id=40b13f88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b13f88",
  null
  
)

export default component.exports